import createIcon from '../../createIcon';

/**
 * @component @name HorizontalDistribute
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCAyMkgyVjJINFYyMlpNMjIgMkgyMFYyMkgyMlYyWk0xMy41IDdIMTAuNVYxN0gxMy41VjdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HorizontalDistribute = createIcon('HorizontalDistribute', [
  ['path', { d: 'M4 22H2V2H4V22ZM22 2H20V22H22V2ZM13.5 7H10.5V17H13.5V7Z', key: '14ycjf' }],
]);

export default HorizontalDistribute;
